import React from 'react'
import { Card } from 'antd'
import cls from 'classnames'
import type { CardProps } from 'antd'
import './index.less'

export interface S3CardProps extends CardProps {}

export default function S3Card({
  className,
  children,
  ...cardProps
}: S3CardProps) {
  return (
    <Card className={cls('s3-card', className)} bordered={false} {...cardProps}>
      {children}
    </Card>
  )
}
